import { CHANNEL_STATE_LABELS } from 'features/plc/contracts/testStand.schema';

const HEADERS = [
  'timestamp',
  'channelId',
  'testName',
  'setupType',
  'subMode',
  'sampleIndex',
  'elapsedMs',
  'samplePeriodMs',
  'vesselPressure',
  'pipetteTipPressure',
  'state',
  'stateLabel',
];

const TIMESTAMP_FORMAT = new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/New_York',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  fractionalSecondDigits: 3,
  hour12: false,
});

function formatTimestamp(ms) {
  if (ms == null) return '';
  return TIMESTAMP_FORMAT.format(new Date(ms));
}

export default function exportCsv(rows, filename) {
  const lines = [
    HEADERS.join(','),
    ...rows.map((r) => HEADERS.map((h) => {
      let v;
      if (h === 'timestamp') v = formatTimestamp(r.time);
      else if (h === 'stateLabel') v = CHANNEL_STATE_LABELS[r.state] ?? '';
      else v = r[h] ?? '';
      return `"${String(v).replace(/"/g, '""')}"`;
    }).join(',')),
  ];
  const blob = new Blob([lines.join('\n')], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
